import { FollowUpSurveyListType } from '../../enums/index';

export const followUpSurveyListTypeMap = [
    { type: FollowUpSurveyListType.AllToDo, url: 'quick-to-do', name: 'Quick To-Do' },
    { type: FollowUpSurveyListType.PendingAll, url: 'pending-all', name: 'All Pending' },
    { type: FollowUpSurveyListType.PendingSurvey, url: 'pending-survey', name: 'Pending Survey' },
    { type: FollowUpSurveyListType.PendingReview, url: 'pending-review', name: 'Pending Review' },
    { type: FollowUpSurveyListType.PendingAppointment, url: 'pending-appointment', name: 'Pending Appointment' },
    { type: FollowUpSurveyListType.PendingLabOrder, url: 'pending-lab-order', name: 'Pending Lab Order' },
    { type: FollowUpSurveyListType.PendingLabResults, url: 'pending-lab-results', name: 'Pending Lab Results' },
    { type: FollowUpSurveyListType.CompleteNoResults, url: 'complete-no-results', name: 'Complete No Results' },
    { type: FollowUpSurveyListType.PendingNotifyDonor, url: 'pending-notify-donor', name: 'Penidng Notify Donor' },
    { type: FollowUpSurveyListType.Complete, url: 'complete', name: 'Complete' },
    { type: FollowUpSurveyListType.Incomplete, url: 'incomplete', name: 'Incomplete' },
    { type: FollowUpSurveyListType.All, url: 'all', name: 'All' },
]